<template>
    <card
        :label-top-left="$t('msg.projects')"
        :label-bottom-left="$t('txt.project.recordPlans')"
        class="p-projects card_max-sm"
        icon="mdi-clipboard-check-outline"
    >
        <template
                slot="header"
        >
            <v-btn
                    small
                    fab
                    color="primary"
                    :to="{name: 'create_project'}"
                    elevation="0"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </template>

        <template v-slot:bottom>
            <filters
                    v-model="filters"
                    :bool-singles="['is_archive']"
                    name="projects"
                    @clear="clearFilters"
            >
                <v-select
                        v-model="filters.is_done"
                        :label="$t('msg.isDone')"
                        class="card__action"
                        :items="$store.state.dict.statuses"
                        item-value="value"
                        item-text="text"
                        clearable
                        @change="loadModels()"
                        outlined
                        :dense="!isMobile"
                        hide-details
                ></v-select>
                <v-autocomplete
                        v-model="filters.tags"
                        :label="$t('msg.markers')"
                        :items="tags"
                        chips
                        deletable-chips
                        small-chips
                        clearable
                        multiple
                        :dense="!isMobile"
                        outlined
                        hide-details
                        class="card__action"
                        hide-selected
                ></v-autocomplete>
                <c-switch
                        v-model="filters.is_archive"
                        :label="$t('msg.inArchive')"
                        @change="loadModels()"
                ></c-switch>
            </filters>
        </template>

        <div v-if="filteredModels.length === 0 && !loading" class="d-flex justify-center">{{ $t('msg.noRecords') }}</div>

        <v-progress-linear
                v-if="loading"
                indeterminate
        ></v-progress-linear>

        <v-simple-table v-if="filteredModels.length > 0 && !loading">
            <thead>
            <tr>
                <th
                    v-for="(item, key) in headers"
                    :key="key"
                    :class="item.className"
                    :width="item.width"
                >{{ item.text }}</th>
            </tr>
            </thead>
            <draggable
                v-model="filteredModels"
                class="task__tasks"
                @change="changeSequence($event)"
                @start="startSequence()"
                handle=".drag"
                tag="tbody"
            >
                <tr
                    v-for="(item, key) in filteredModels"
                >
                    <td
                            :class="{
                                    'pt-1 pb-1 pr-0 pl-0': $vuetify.breakpoint.xsOnly,
                                    'p-projects__name p-projects__name_mobile': $vuetify.breakpoint.xsOnly
                            }"
                            style="cursor: pointer;"
                            @click="$router.push({name: 'tasks', params: {id: item.id}})"
                    >
                        <router-link
                            :to="{name: 'tasks', params: {id: item.id}}"
                            style="color: #333"
                        >{{ item.name }}</router-link>
                        <div v-if="$vuetify.breakpoint.xsOnly" class="p-projects__tags">
                            <tags v-model="item.tag"></tags>
                        </div>
                    </td>
                    <td v-if="!$vuetify.breakpoint.xsOnly">
                        <tags v-model="item.tag"></tags>
                    </td>
                    <!--<td>
                        {{ item.complete_percent | numFormat('0,0.0') }} %
                        <v-progress-linear
                            :value="item.complete_percent"
                        ></v-progress-linear>
                    </td>-->
                    <!--<td v-if="$vuetify.breakpoint.mdAndUp" class="p-projects__date">
                        <template v-if="item.start_at !== null || item.end_at !== null">
                            {{ item.start_at }} - {{ item.end_at }}
                        </template>
                    </td>-->
                    <td class="p-projects__actions">
                        <actions
                            edit="edit_project"
                            :id="item.id"
                        >
                            <template v-slot:after>
                                <v-icon
                                        v-if="!$vuetify.breakpoint.xsOnly"
                                        class="drag"
                                >mdi mdi-drag</v-icon>
                            </template>
                        </actions>
                    </td>
                    <td
                            class="p-projects__color"
                            :class="{
                                'p-projects__color_desktop': !$vuetify.breakpoint.xsOnly,
                                'p-projects__color_mobile': $vuetify.breakpoint.xsOnly
                            }"
                            :style="{
                                'background-color': item.color
                            }"
                    ></td>
                </tr>
            </draggable>
        </v-simple-table>

    </card>
</template>

<script>
    import Actions from '../../../components/ui/Actions';
    import Filters from '../../../components/ui/Filters';
    import Draggable from 'vuedraggable';
    import Tag from "../../../components/ui/Tag";
    import Tags from "../../../components/ui/Tags";
    import {format} from "date-fns";
    import CSwitch from "../../../components/ui/CSwitch";

    export default {
        components: {Actions, Filters, Draggable, Tag, Tags, CSwitch},
        data() {
            return {
                loading: false,
                models: [],
                tags: [],
                filters: {
                    is_done: false,
                    tags: [],
                    is_archive: false
                },
                sequenceModels: [],
            }
        },
        computed: {
            headers() {
                let items = [
                    {text: this.$t('msg.name'), className: 'text-left p-projects__name'},
                    {text: this.$t('msg.markers'), className: 'text-center', show: !this.$vuetify.breakpoint.xsOnly},
                    // {text: this.$t('msg.progress'), className: 'text-center'},
                    // {text: this.$t('msg.dates'), className: 'text-left', show: this.$vuetify.breakpoint.mdAndUp},
                    {text: this.$t('msg.actions'), className: 'text-center p-projects__actions'},
                    {className: 'p-projects__color'}
                ];
                return items.filter(v => v.show === undefined || v.show);
            },
            filteredModels: {
                get: function() {
                    return this.models.filter(model => {

                        let tags = () => {
                            if (this.filters.tags.length === 0) return true;
                            for (let key in model.tag) {
                                if (this.filters.tags.includes(model.tag[key])) {
                                    return true
                                }
                            }
                            return false;
                        };

                        let isDone = () => {
                            if (typeof this.filters.is_done !== 'boolean') return true;
                            return this.filters.is_done === model.is_done;
                        };

                        let isArchive = () => {
                            return model.is_archive === this.filters.is_archive;
                        };

                        return tags() && isDone() && isArchive();
                    });
                },
                set: function(v) {
                    this.models = v
                }
            }
        },
        methods: {
            clearFilters() {

                this.filters.is_archive = false;
                this.filters.is_done = false;
                this.filters.tags = [];

                this.loadModels();
            },
            loadModels() {
                this.loading = true;
                this.$store.dispatch('loadProjects')
                    .then(res => {
                        res.forEach((item, i) => {
                            let start = this.dateServerToLocal(item.start_at);
                            let end = this.dateServerToLocal(item.end_at);
                            res[i].start_at = start !== null ? format(start, 'yyyy-MM-dd') : null;
                            res[i].end_at = end !== null ? format(end, 'yyyy-MM-dd') : null;
                        });
                        this.models = res;
                        this.sequenceModels = res;
                        this.collectTags();
                    })
                    .finally(() => this.loading = false);
            },
            collectTags() {
                this.tags = [];
                this.models.forEach(model => {
                    model.tag.forEach(tag => {
                        if (!this.tags.includes(tag)) {
                            this.tags.push(tag);
                        }
                    });
                })
            },
            changeSequence(event) {

              let res = this.recountSequenceModels(this.models, this.sequenceModels, event);

              this.sequenceModels = res.models;

              this.$store.dispatch('changeProjectSequence', {
                id: res.id,
                data: {
                  from_seq: res.from,
                  to_seq: res.to,
                },
              });
            },
            startSequence() {
              this.sequenceModels = this.models;
            },
        },
        created() {
            this.loadModels();
        }
    }
</script>

<style lang="scss">
    .p-projects {
        .p-projects__name {
            width: 100%;

            &.p-projects__name_mobile {
                word-break: break-all;
            }
        }
        .p-projects__date {
            white-space: nowrap;
        }
        .p-projects__actions {
            padding-right: 10px;
        }
        .p-projects__color {
            padding: 0;

            &.p-projects__color_desktop {
                min-width: 20px;
            }
            &.p-projects__color_mobile {
                min-width: 10px;
            }
        }
        .tags {
            justify-content: center;

            .tag {
                margin: 1px;
            }
        }
      .p-projects__tags {
        display: flex;
        align-items: flex-start;
        margin: 4px 0;
      }
    }
</style>